import clsx from 'clsx';

import {Figure} from '@/modules/foundation/components/figure';
import {ImageBlock} from '@/modules/foundation/components/image/ImageBlock';
import type {ImageWeb} from '@/modules/foundation/components/image/types';

interface Props {
	image: ImageWeb;
}

const classNameOverride = {
	figure: 'my-9',
};

export const PortableImage = ({image}: Props) => {
	if (!image) {
		return null;
	}

	if (image.caption || image.credit) {
		return (
			<Figure
				credit={image.credit}
				caption={image.caption}
				classNameOverride={classNameOverride}
			>
				<ImageBlock
					height={image.image.height}
					src={image.image.src}
					width={image.image.width}
					alt={image.altText ?? ''}
					className={clsx('mb-2', 'rounded-sm')}
				/>
			</Figure>
		);
	}

	return (
		<ImageBlock
			height={image.image.height}
			src={image.image.src}
			width={image.image.width}
			alt={image.altText ?? ''}
			className={classNameOverride.figure}
		/>
	);
};
